type Content = {
  content?: Content[];
  nodeType: string;
  value?: string;
  marks: [];
  data: any;
};

// TODO: Improve handling of paragraphs vs other nodes,
// potentially only flattening first paragraph for simple descriptions
export default function getPlaintextDescription(recipe: Recipe) {
  // Flatten all content chunks
  // into a single string of all their values combined
  const getContentSubstring = (block: Content): string => {
    if (block?.content) {
      return (
        block.content
          .map((c: Content) => {
            return getContentSubstring(c);
          })
          .join("") + " "
      );
    }

    return block?.value ?? "";
  };

  const content = recipe.richDescription?.json as Content;
  return getContentSubstring(content).trim();
}
